import React, { Component } from 'react'
import style from './style.css';

const Fade = ({ styles }) => {
    return (
        <div className={ style.fade } style={ styles ? styles : { display: 'block'}  }></div>
    )
} 
export default Fade



// WEBPACK FOOTER //
// ./src/components/pagescreen/fade/index.js